export type VideoPlayback = "native-hls" | "hls-js" | "original";

export interface PlaybackCapabilities {
  supportsNativeHls: boolean;
  supportsMediaSource: boolean;
}

const HLS_MIME_TYPE = "application/vnd.apple.mpegurl";

/**
 * Native HLS wins over hls.js: Safari decodes it in hardware and hls.js would
 * not save it a request.
 */
export function selectPlayback(
  hlsSrc: string | undefined,
  capabilities: PlaybackCapabilities
): VideoPlayback {
  if (!hlsSrc) return "original";
  if (capabilities.supportsNativeHls) return "native-hls";
  if (capabilities.supportsMediaSource) return "hls-js";
  return "original";
}

export function detectPlaybackCapabilities(
  element: HTMLVideoElement
): PlaybackCapabilities {
  return {
    supportsNativeHls: element.canPlayType(HLS_MIME_TYPE) !== "",
    supportsMediaSource:
      "MediaSource" in window || "ManagedMediaSource" in window,
  };
}
